<div class="row mb-3">
	<label class="col-form-label text-end" [ngClass]="labelClass" [for]="id">
		<ng-container *ngIf="label">
			<span [innerHTML]="label"></span>
		</ng-container>

		<ng-container *ngIf="!label">
			<ng-content></ng-content>
		</ng-container>
	</label>

	<div [ngClass]="inputClass">
		<select class="form-select" [id]="id" [name]="name" [(ngModel)]="value" [required]="required" [disabled]="disabled || source?.length == 0" [class.is-invalid]="!isValid">
			<option [selected]="true" [ngValue]="null">
				<ng-container *ngIf="source?.length == 0">
					{{ emptyHint }}
				</ng-container>

				<ng-container *ngIf="source?.length > 0">
					{{ placeholder }}
				</ng-container>
			</option>

			<option *ngFor="let entry of source" [value]="entry[itemValue]">
				{{ entry[itemLabel] }}
			</option>
		</select>

		<div *ngIf="hint" class="form-text text-muted" [innerHTML]="hint"></div>
	</div>
</div>
